import { render, staticRenderFns } from "./CustomerOnboarding.vue?vue&type=template&id=0cb7e1ad&scoped=true"
import script from "./CustomerOnboarding.vue?vue&type=script&lang=js"
export * from "./CustomerOnboarding.vue?vue&type=script&lang=js"
import style0 from "./CustomerOnboarding.vue?vue&type=style&index=0&id=0cb7e1ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb7e1ad",
  null
  
)

export default component.exports